import { createMetaDef } from '@exodus/asset'

const name = 'harmonymainnet'
const displayName = 'Harmony One'
const ticker = 'ONEMAINNET'
const displayTicker = 'ONE'
const primaryColor = '#EAEAEA'
const gradientColors = ['#EAEAEA', '#FFF']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = gradientColors
const chainId = 1_666_600_000

const units = {
  wei: 0,
  Kwei: 3,
  Mwei: 6,
  Gwei: 9,
  [ticker]: 18,
}

const assetType = 'ETHEREUM_LIKE'
const tokenAssetType = 'HARMONYMAINNET_ERC20'
const blockExplorer = {
  addressUrl: (accountId) =>
    `https://explorer.harmony.one/address/${encodeURIComponent(accountId)}`,
  txUrl: (txId) => `https://explorer.harmony.one/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Harmony is a fast and secure blockchain for decentralized applications. with sharding and effective proof of stake  producing blocks in 2 seconds with finality.',
  reddit: 'https://reddit.com/r/harmony_one',
  twitter: 'https://twitter.com/harmonyprotocol',
  website: 'https://harmony.one/',
  telegram: 'https://t.me/harmony_one',
  discord: 'https://discordapp.com/invite/rdCmBpe',
}

const assetParams = {
  assetType,
  blockExplorer,
  chainBadgeColors,
  chainId,
  displayName,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  ticker,
  tokenAssetType,
  units,
}

export const { asset, tokens, assetsList } = createMetaDef({
  assetParams,
})

export default assetsList
